import http from "plugins/axios";

export default {
  getUserList(data) {
    return http.get({
      url: `/la/admin/channel/getChannelNextList`,
      data
    });
  },

  // 升级合伙人
  upgradePartner({ userId, channelId, rate }) {
    return http.post({
      url: `/channel/partner/addChannel?channelId=${channelId}&userId=${userId}&rate=${rate}`,
    });
  },
  // 设置返佣比例
  upgradeRate({ userId, channelId, rate }) {
    return http.post({
      url: `/channel/partner/rebateRate?channelId=${channelId}&userId=${userId}&rate=${rate}`,
    });
  },
};
